// UMBC's undergraduate majors (#2652, round 2). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Academic Programs A-Z page
// (catalog.umbc.edu, catoid=42, navoid=3108), whose "Major" list names each
// bachelor's program and its degree (B.A., B.S., B.F.A.): every line kept,
// in the catalog's A to Z order, as one group (the catalog does not group
// majors by college). Minors, certificates, pre-professional tracks and
// graduate programs left out. The catalog blocks curl with an AWS WAF
// challenge; the page was read with the lane's headless-browser script.
// One curly apostrophe made straight ("Gender, Women's, and Sexuality
// Studies"). 58 lines.
const majors = {
    "slug": "university-of-maryland-baltimore-county",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UMBC's official 2026-2027 Undergraduate Catalog, listed A to Z as the catalog lists them, with the degree it leads to. Minors, certificates, pre-professional tracks and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors, A to Z",
            "source": {
                "label": "UMBC 2026-2027 Undergraduate Catalog, Academic Programs A-Z",
                "url": "https://catalog.umbc.edu/content.php?catoid=42&navoid=3108"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ancient Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Bioinformatics and Computational Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biology Education",
                    "degree": "B.A."
                },
                {
                    "name": "Business Technology Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry Education",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Emergency and Disaster Health Systems",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Financial Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Gender, Women's, and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography and Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Study",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Study",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Jazz Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Management of Aging Services",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Media and Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Grades STEM",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Languages and Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Music Composition",
                    "degree": "B.A."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.A."
                },
                {
                    "name": "Music Teaching and Learning",
                    "degree": "B.A."
                },
                {
                    "name": "Music Technology",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Translational Life Science Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.F.A."
                }
            ]
        }
    ]
};

export default majors;
